import * as React from "react";
import { forwardRef } from "react";
const SvgSubdirRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3, width: 1, height: 10, fill: "#D0D2D4" }), /* @__PURE__ */ React.createElement("rect", { x: 13, y: 12, width: 1, height: 10, transform: "rotate(90 13 12)", fill: "#D0D2D4" }));
const ForwardRef = forwardRef(SvgSubdirRight);
export default ForwardRef;
